import { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useRouter } from 'next/router';

import { BaseButton, btnSizes, btnTypes } from '@r1-frontend/ui-react/components/buttons/baseButton';
import { EResultPopupStatus } from '@r1-frontend/ui-react/components/popups/popupResult';
import { RubleSymbol } from '@r1-frontend/ui-react/experimental/purchase/cost/Cost/RubleSymbol';

import { PaymentBlock } from '~/src/features/payments-abn/components/PaymentBlock';
import ResultPopup, { defaultPopupState } from '~/src/features/payments-abn/components/PopupResult';
import { setPaymentResult } from '~/src/features/payments-abn/store/actionCreators';
import { initialPaymentResult } from '~/src/features/payments-abn/store/reducers';
import PaymentBanner from '~/src/features/payments-unauth-abn/components/PaymentBanner';
import PaymentType from '~/src/features/payments-unauth-abn/components/PaymentType';
import { usePrepareQueryData } from '~/src/helpers/hooks/usePrepareQueryData';
import { TState } from '~/src/store';
import { openChat } from '~/src/store/actions/chat';

import { ErrorDisconnectText } from '~/src/features/payments-abn/components/CardsList/styled';
import * as ST from './styled';

const PaymentsUnAuthLayout = (): JSX.Element => {
    const dispatch = useDispatch();

    const router = useRouter();
    // TODO заменить на useRouter<IQueryPaymentParams>
    const { s: queryPaySum } = usePrepareQueryData();

    const {
        payment: { paymentData: { paymentSum, agreement }, result: { isOpenPopup, isPayCardSuccess, payStatus, queryAgreement: payAgreement } },
    } = useSelector((state: TState) => state);

    const [popupState, setPopupState] = useState(defaultPopupState);
    const [isCloseFrame, setIsCloseFrame] = useState(false);

    const onCloseHandler = useCallback(() => {
        dispatch(setPaymentResult(initialPaymentResult));
        setPopupState(defaultPopupState);

        if (popupState.type === 'success') {
            router.push('/');
        }
    }, [popupState.type, router]);

    useEffect(() => {
        const isSuccess = isPayCardSuccess && (payStatus === 1 || payStatus === 2);

        setPopupState({
            isOpen: isOpenPopup,
            type: isSuccess ? EResultPopupStatus.SUCCESS : EResultPopupStatus.ERROR,
            title: isSuccess ? `Вы оплатили услуги по договору ${payAgreement}` : 'Платёж не прошёл',
            text: isSuccess
                ? `Баланс пополнен на ${paymentSum} ${RubleSymbol}`
                : <ErrorDisconnectText>
                    Попробуйте ещё раз или напишите в&nbsp;<p onClick={() => dispatch(openChat())}>поддержку</p>
                </ErrorDisconnectText>,
            actions: <BaseButton
                type={btnTypes.SECONDARY}
                size={btnSizes.LARGE}
                text={'Закрыть'}
                onClick={onCloseHandler}
            />,
        });
    }, [agreement, isOpenPopup, isPayCardSuccess, payStatus, onCloseHandler, payAgreement, paymentSum]);

    return (
        <>
            <ST.PageTitle>Оплата услуг</ST.PageTitle>
            <ST.PageContent>
                <ST.InfoBlock>
                    <PaymentType
                        isCloseFrame={isCloseFrame}
                        setIsCloseFrame={setIsCloseFrame}
                    />
                    <PaymentBanner/>
                </ST.InfoBlock>
                <ST.ActionsBlock>
                    <PaymentBlock paymentSum={+queryPaySum}/>
                    <ResultPopup {...popupState} onClose={onCloseHandler} isLoading={true}/>
                </ST.ActionsBlock>
            </ST.PageContent>
        </>
    );
};

export default PaymentsUnAuthLayout;
